import * as React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    minHeight: '300px',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

type Props = {
  children: string | JSX.Element;
};

/**
 * @summary Компонент для отображения сообщения об отсутствии данных.
 *
 * @param props.children - Компонент, отображающийся при отсутствии данных в таблице.
 */
export const EmptyData: React.FC<Props> = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};

EmptyData.displayName = 'EmptyData';

export type EmptyDataType = typeof EmptyData;
export type EmptyDataRender = React.FunctionComponentElement<Props>;
